'use client';

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Moment from 'moment';
import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import DisplayStarRating from 'src/components/shared/display-star-rating';
import Loader from 'src/components/shared/loader';
import { getReview } from 'src/services/jobs';

interface ReviewItem {
  tenant_contact_review_request_id?: string;
  lula_rating?: string | number;
  rating?: string | number;
  review_text?: string;
  reviewed_by_name?: string;
  created_at?: string;
  [key: string]: unknown;
}

interface JobData {
  jobId?: string;
  jobNo?: string;
}

interface ReviewModalProps {
  showReview: boolean;
  toggle: () => void;
  jobData?: JobData;
  source?: ReviewItem[];
}

const ReviewModal = ({
  showReview, toggle, jobData, source,
}: ReviewModalProps) => {
  const [reviews, setReviews] = useState<ReviewItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (source) {
      setReviews(source || []);
    } else if (jobData?.jobId) {
      setLoading(true);
      getReview(jobData?.jobId).then((res) => {
        setReviews(res?.data as ReviewItem[]);
      }).catch((e: { error?: string }) => {
        toggle();
        toast(e?.error || 'Something went wrong', { type: 'error' });
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [jobData?.jobId, source, toggle]);

  return (
    <Modal
      isOpen={showReview}
      toggle={toggle}
      centered
      className="review-job-modal review-modal"
    >

      <ModalHeader toggle={toggle}>
        {jobData?.jobNo ? (
          <React.Fragment>
            Review for Job&nbsp;
            <button type="button" className="link-btn">
              #
              {jobData?.jobNo}
            </button>
          </React.Fragment>
        ) : ''}
      </ModalHeader>
      <ModalBody>
        {loading ? <Loader />
          : (
            <div className="tenant-review-outer">
              {Array.isArray(reviews) && reviews?.map((review) => (
                <div
                  className="tenant-review-card"
                  key={review?.tenant_contact_review_request_id}
                >
                  <div className="rating-wrapper">
                    <DisplayStarRating
                      ratingValue={review?.lula_rating
                        ? Number(review?.lula_rating)
                        : Number(review?.rating)}
                      totalStars={5}
                      rectFill="#F3F7FF"
                    />
                  </div>
                  {review?.review_text ? (
                    <h6>
                      <i>
                        &quot;
                        {review?.review_text || ''}
                        &quot;
                      </i>
                    </h6>
                  ) : ''}
                  <h5>
                    {review?.reviewed_by_name || ''}
                  </h5>
                  <p>
                    { Moment.utc(review?.created_at).local().format(
                      'MMM DD, YYYY hh:mm A',
                    ) || ''}
                  </p>
                </div>
              ))}
            </div>
          )}
      </ModalBody>
    </Modal>
  );
};
export default ReviewModal;
